// extracted by mini-css-extract-plugin
module.exports = {"quoteContent":"Quote_quoteContent__2peqc","quoteSource":"Quote_quoteSource__3Gzgx"};